import MidMonthPaysComponent from 'components/Payroll/MidMonthPay';
import PermissionGuard from 'components/Global/PermissionGuard'; 

export const MidMonthPay = () => {
	return (
		<PermissionGuard permission="Allow_Mid-Month_Pay">
			<MidMonthPaysComponent />
		</PermissionGuard>
	);
};
